import React, {useState} from 'react';
import Menu from "./Menu";

const CustomInput = ({value='',onChange=()=>{},style={},disabled=false,className}) => {
    const [text, setText] = useState(value || '')
    const [context, setContext] = useState(<></>)
    const close = () => {
        setContext(<></>)
    }
    const clickHandler = (e) => {
        e.preventDefault();
        setContext(<Menu close={close}
                         changeText={onTextChange}
                         element={e}/>)
    }
    const onTextChange = (e) => {
        setText(e.target.value)
        onChange(e)
    }

    return (
        <>
            {context}
            <input type="text" value={text} onChange={event => onTextChange(event)} style={style} disabled={disabled}
                   className={className} onContextMenu={e => clickHandler(e)}/>

        </>
    );
}

export default CustomInput;